<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  import Article from './components/Article'

  export default {
    name: 'app',
    components: {
      Article
    },
    mounted () {
      if (!this.$store.state.signedIn) {
        this.$router.push('/introduction')
      }
      this.$store.dispatch('getArticles')
    }
  }
</script>

<style>
  body {
    margin: 0;
    background-color: #DBE2EC;
  }

  #app {
    font-family: 'henriette', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  li {
    margin: 0 !important;
  }

  h1,
  h2,
  h3 {
    font-family: "stevie-sans", sans-serif;
    font-weight: 300;
  }

  h1 {
    font-size: 3em;
    padding-bottom: 1rem;
    margin-top: 0;
    margin-bottom: 0;
    border-top: 2px solid #2c3e50;
  }

  * {
    box-sizing: border-box;
  }

  p {
    line-height: 1.65;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue